/* eslint-disable */
import VueStoreService from './VueStoreService';

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

const ImportBatchService = {
  async uploadSales(file, store, onUploadProgress) {
    const form = new FormData();
    form.append('file', file);

    if (typeof onUploadProgress === 'function') {
      onUploadProgress({ loaded: 0, total: file.size || 1, kickoff: true });
    }

    if (typeof VueStoreService.postFile === 'function') {
      return await VueStoreService.postFile('imports/sales', form, store, {
        onUploadProgress: (evt) => {
          if (typeof onUploadProgress === 'function') {
            onUploadProgress({
              loaded: evt?.loaded ?? 0,
              total : evt?.total  || file.size || 1,
            });
          }
        },
      });
    }

    if (typeof VueStoreService.post === 'function') {
    return await VueStoreService.post('imports/sales', form, store, {
      onUploadProgress: (evt) => {
        if (typeof onUploadProgress === 'function') {
          onUploadProgress({
            loaded: evt?.loaded ?? 0,
            total : evt?.total  || file.size || 1,
          });
        }
      },
    });
  }

    return await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'imports/sales', true);
      xhr.withCredentials = true;

      xhr.upload.onprogress = (evt) => {
        if (evt && evt.lengthComputable && typeof onUploadProgress === 'function') {
          onUploadProgress({ loaded: evt.loaded, total: evt.total });
        }
      };

      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) return;
        if (xhr.status >= 200 && xhr.status < 300) {
          try { resolve(JSON.parse(xhr.responseText || '{}')); }
          catch { resolve({}); }
        } else {
          reject(new Error(`Upload failed (${xhr.status})`));
        }
      };

      xhr.onerror = () => reject(new Error('Network error'));
      xhr.send(form);
    });
  },

  async exportErrors(batchId, store) {
    if (typeof VueStoreService.get === 'function') {
      const res = await VueStoreService.get(
        `imports/${batchId}/errors/export`,
        store,
        { responseType: 'blob' }
      );
      const blob = res?.data instanceof Blob ? res.data : new Blob([res]);
      downloadBlob(blob, `errores_batch_${batchId}.xlsx`);
      return true;
    }

    const res = await fetch(`imports/${batchId}/errors/export`, {
      method: 'GET',
      credentials: 'include',
    });
    if (!res.ok) throw new Error('No se pudo descargar los errores');
    const blob = await res.blob();
    downloadBlob(blob, `errores_batch_${batchId}.xlsx`);
    return true;
  },

  async deleteBatch(batchId, store) {
    return VueStoreService.delete(`imports/${batchId}`, store);
  },

  async getSummary(batchId, store) {
    return VueStoreService.get(`imports/${batchId}/summary`, store);
  },

  async listRows(batchId, { status = 'OK', offset = 0, limit = 20 } = {}, store) {
    const q = `status=${encodeURIComponent(status)}&offset=${offset}&limit=${limit}`;
    return VueStoreService.get(`imports/${batchId}/rows?${q}`, store);
  },

  listBatches({ offset = 0, limit = 50 } = {}, store) {
    return VueStoreService.get(`imports?offset=${offset}&limit=${limit}`, store);
  },

  async exportExcel(batchId, status = 'ALL', store) {
    if (typeof VueStoreService.get === 'function') {
      const res = await VueStoreService.get(
        `imports/${batchId}/export?status=${encodeURIComponent(status)}`,
        store,
        { responseType: 'blob' }
      );
      const blob = res?.data instanceof Blob ? res.data : new Blob([res]);
      downloadBlob(blob, `batch_${batchId}_${status.toLowerCase()}.xlsx`);
      return true;
    }

    const resp = await fetch(
      `imports/${batchId}/export?status=${encodeURIComponent(status)}`,
      { method: 'GET', credentials: 'include' }
    );
    if (!resp.ok) throw new Error('No se pudo exportar el Excel');
    const blob = await resp.blob();
    downloadBlob(blob, `batch_${batchId}_${status.toLowerCase()}.xlsx`);
    return true;
  },
};

export default ImportBatchService;
